import { useFormik } from 'formik'
import React, { useContext, useEffect, useState } from 'react'

import { CustomSection, CustomSectionTitle, CustomSectionsWrapper, InputProperty, Text, Type, inputs } from 'components'
import { ProjectContext } from 'context'
import { database } from 'services/firebase'
import { ValueType } from 'utils'
import { SettingsLayout } from '../components'

const properties: InputProperty[] = [
  {
    name: 'screenshots',
    type: ValueType.screenshots,
    position: 0,
    title: 'App screenshots',
    helpText:
      'Upload or generate up to 10 high-quality screenshots to showcase your app on the iOS and Android app stores.',
  },
]

export const Screenshots: React.FC = () => {
  const {
    project: { id },
  } = useContext(ProjectContext)
  const [configWait, setConfigWait] = useState(true)
  const configRef = database.ref(`projects/${id}/configurations/storemanager`)

  const formik = useFormik({
    initialValues: {},
    onSubmit: () => {},
  })

  useEffect(() => {
    configRef.on('value', snapshot => {
      const config = snapshot.val()
      if (config) {
        console.log('GET STOREMANAGER CONFIG')
        formik.setValues({ screenshots: config.screenshots || null })
        setConfigWait(false)
      }
    })
    return () => {
      configRef.off('value')
    }
  }, [])

  return (
    <SettingsLayout>
      <Text type={Type.TITLE}>Screenshots</Text>
      <Text type={Type.SUB_TITLE} styles={{ marginBottom: '40px' }}>
        Create panoramic, studio-quality screenshots for your iOS and Android apps.
      </Text>
      {configWait ? (
        <></>
      ) : (
        <CustomSectionsWrapper>
          <CustomSection>
            <CustomSectionTitle mb="-5px">App Screenshots</CustomSectionTitle>
            {inputs(properties, formik)}
          </CustomSection>
        </CustomSectionsWrapper>
      )}
    </SettingsLayout>
  )
}
